import { orderBy } from 'lodash';
import States from 'states-us';

const states = [
    ...States,
    {
        name: 'Armed Forces - Americas',
        abbreviation: 'AA',
        contiguous: false,
        territory: false,
    },
    {
        name: 'Armed Forces - Europe',
        abbreviation: 'AE',
        contiguous: false,
        territory: false,
    },
    {
        name: 'Armed Forces - Pacific',
        abbreviation: 'AP',
        contiguous: false,
        territory: false,
    },
];

const ORDERED_STATES = orderBy(states, ['name'], ['asc']);

export { states, ORDERED_STATES };
